import { DataView24 } from "@carbon/icons-react";
import {
  DataTable,
  Select,
  SelectItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from "carbon-components-react";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "../../components/Card/Card";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";
import TablePagination from "../../components/Pagination/Pagination";

const tableHeaders = [
  // {
  //   header: "NUR",
  //   key: "nur",
  // },
  {
    header: "# Plano de Negócio",
    key: "order",
  },
  {
    header: "Janela",
    key: "windowDesc",
  },
  {
    header: "Total",
    key: "totalScore",
  },
  {
    header: "Conversão",
    key: "conversion",
  },
  {
    header: "Consultar",
    key: "actions",
  },
];

const LinkList = ({ url }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url} title="Consultar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "totalScore") {
    return cell.value != null ? parseFloat(cell.value).toFixed(2) : "";
  }
  if (cell.info.header === "conversion") {
    return cell.value != null ? parseFloat(cell.value).toFixed(2) + "%" : "";
  }
  if (cell.info.header === "actions") {
    return <LinkList url={"../plano-de-negocio-juri/" + id} />;
  }
  return cell.value;
};

const BusinessPlanEvaluationPage = () => {
  const { user } = useContext(AuthContext);
  const [businessPlans, setBusinessPlans] = useState([]);
  const [submissionWindow, setSubmissionWindow] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const getJuryBusinessPlans = async (window = submissionWindow) => {
    try {
      const params = window ? `?submissionWindow=${window}` : "";
      const response = await http.get(
        `/business-plan/jury-business-plans/${user.username}${params}`
      );
      setBusinessPlans(response.data);
      setPage(1);
    } catch (error) {
      console.error("Error fetching jury business plans:", error);
    }
  };

  useEffect(() => {
    getJuryBusinessPlans("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeWindow = (event) => {
    const window = event.target.value;
    setSubmissionWindow(window);
    getJuryBusinessPlans(window);
  };

  const onPageChange = ({ page: nextPage, pageSize: nextPageSize }) => {
    setPage(nextPage);
    setPageSize(nextPageSize);
  };

  const visibleBusinessPlans = businessPlans.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  return (
    <Card title="Avaliação de Planos de Negócio">
      <div style={{ width: "9rem", marginBottom: "1rem" }}>
        <Select
          id="evaluation-submission-window"
          labelText="Janela"
          value={submissionWindow}
          onChange={changeWindow}
          size="sm"
        >
          <SelectItem value="" text="Todas" />
          <SelectItem value="JANELA_1" text="Janela 1" />
          <SelectItem value="JANELA_2" text="Janela 2" />
        </Select>
      </div>
      <DataTable
        rows={visibleBusinessPlans}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        key={submissionWindow}
        currentPageSize={pageSize}
        onPageChange={onPageChange}
        totalItems={businessPlans.length}
      />
    </Card>
  );
};

export default BusinessPlanEvaluationPage;
